import $ from 'jquery'
import manager from '../manager'
import { INTERFACE } from '@/utils/INTERFACE'
import http from '@/utils/http'
var cache = null

manager.add('shopInfo', {
  async created() {

    let $dom = $(this.dom);
    let real = $dom.find('.J_realLogo').val();

    try {
      let data = cache
      if (!data) {
        data = await http.get(INTERFACE().getVenderInfo)
        cache = data
      }

      $dom.find('.J_shop-name').text(data.shopName);
      if (real !== 'true') {
        $dom.find('.J_logo').attr('src', data.shopLogo);
      } else {
        if ($dom.find('.J_logo').attr('src').trim() === '') {
          $dom.find('.J_logo').attr('src', data.shopLogo);
        }
      }
    } catch (e) {
      // statements

    }
  },
  destroyed() {}
})
